<app-module-layout
    *ngIf="moduleIsActive"
    [name]="title + ' ' + currentPeriod.name"
    [navigation]="[
        { label: 'Historial', url: '/inscription/history', iconClass: 'unordered-list' },
        { label: 'incripciones', url: '/inscription/form', iconClass: 'form' },
        { label: 'Información', url: '/inscription/info', iconClass: 'info-circle' }
    ]"
></app-module-layout>
<div class="club-socio-page" *ngIf="moduleIsActive === false">
    <app-message
        [message]="'El módulo de academias se encuentra en mantenimiento'"
        [subMessage]="'Estamos preprando las academias para un nuevo mes de Inscripciones, <br>  '"
        [icon]="'cogs'"
    ></app-message>
</div>
